import { useEffect, useRef, useState } from "react";
import { FiCheck, FiChevronDown, FiDroplet, FiMoon, FiSun } from "react-icons/fi";
import { useTheme } from "../../theme/ThemeContext";

const ThemeToggle = () => {
  const { theme, mode, themes, toggleMode, selectTheme, setMode } = useTheme();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  const hasMultipleThemes = themes.length > 1;

  return (
    <div className="theme-controls">
      <button
        type="button"
        className="icon-btn"
        onClick={toggleMode}
        aria-label={`Switch to ${mode === "dark" ? "light" : "dark"} mode`}
        title={`Switch to ${mode === "dark" ? "light" : "dark"} mode`}
      >
        {mode === "dark" ? <FiSun /> : <FiMoon />}
      </button>

      {hasMultipleThemes && (
        <div className="theme-menu" ref={menuRef}>
          <button
            type="button"
            className="icon-btn theme-menu-trigger"
            onClick={() => setOpen((o) => !o)}
            aria-haspopup="true"
            aria-expanded={open}
            title="Change theme"
          >
            <FiDroplet />
            <FiChevronDown className="chev" />
          </button>
          {open && (
            <div className="theme-popover" role="menu">
              <div className="theme-popover-label">Theme</div>
              {themes.map((t) => (
                <button
                  key={t.id}
                  type="button"
                  className="theme-option"
                  onClick={() => {
                    selectTheme(t.id);
                    setOpen(false);
                  }}
                >
                  <span>{t.label}</span>
                  {t.id === theme && <FiCheck />}
                </button>
              ))}
              <div className="theme-popover-sep" />
              <div className="theme-popover-label">Mode</div>
              <div className="theme-mode-row">
                <button
                  type="button"
                  className={`theme-mode-btn${mode === "light" ? " is-active" : ""}`}
                  onClick={() => setMode("light")}
                >
                  <FiSun /> Light
                </button>
                <button
                  type="button"
                  className={`theme-mode-btn${mode === "dark" ? " is-active" : ""}`}
                  onClick={() => setMode("dark")}
                >
                  <FiMoon /> Dark
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ThemeToggle;
